import { createSlice } from "@reduxjs/toolkit";

const appSlice = createSlice({
  name: 'app',
  initialState: {
    sidebar: {
      pinned: false,      // desktop: sidebar expands on hover
      mobileOpen: false,  // mobile: drawer is open
    },
    isModalOpen: false,
    params: {},
  },
  reducers: {
    toggleSidebarPin: (state) => {
      state.sidebar.pinned = !state.sidebar.pinned;
    },
    setSidebarPinned: (state, action) => {
      state.sidebar.pinned = action.payload;
    },
    setSidebarMobileOpen: (state, action) => {
      state.sidebar.mobileOpen = action.payload;
    },
    closeSidebarMobile: (state) => {
      state.sidebar.mobileOpen = false;
    },
    setOpenModal: (state, action) => {
      state.isModalOpen = action.payload;
    },
    setParams: (state, action) => {
      state.params = action.payload;
    },

    // Backward-compatible actions (used by un-migrated components)
    toggleMenu: (state) => {
      state.sidebar.pinned = !state.sidebar.pinned;
      state.sidebar.mobileOpen = !state.sidebar.mobileOpen;
    },
    closeMenu: (state) => {
      state.sidebar.mobileOpen = false;
    },
  },
});

export const {
  toggleSidebarPin,
  setSidebarPinned,
  setSidebarMobileOpen,
  closeSidebarMobile,
  setOpenModal,
  setParams,
  toggleMenu,
  closeMenu,
} = appSlice.actions;

// Selectors
export const selectSidebar = (state) => state.app.sidebar;
export const selectSidebarPinned = (state) => state.app.sidebar.pinned;
export const selectSidebarMobileOpen = (state) => state.app.sidebar.mobileOpen;

export default appSlice.reducer;
